import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';

export default class GallerySlider extends Module {
    ready(app) {
        new Swiper('.mtt-gallery-slider .swiper-container', {
            slidesPerView: 1,
            speed: 800,
            spaceBetween: 0,
            freeMode: false,
            watchOverflow: true,
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
}